// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"750":"pacientes","966":"dashboard"}[chunkId] + "." + {"750":"0b5de706","966":"0f00aa90"}[chunkId] + ".css";
};